import React from 'react'
import FormReport from "../../../../../../components/pages/inventory/ReportInventory";
import { useFetch } from '../../../../../../hooks/useFetch';

export default () => {

    return (
        <FormReport
            title={'Distribusi Current Now'}
            repType={'current_now'}
            url={"/api/v1/report_distribusi"}
            FetchComponent={useFetch}
        />
    )
}